import VConsole from 'vconsole'

const createVConsoleInstance = () => {
  let instance = ''
  try {
    const isNonWebAndNonProd = (process.env.clientType !== 'web' && process.env.runtime !== 'prod')

    const getParam = (key) => {
      if (typeof window === 'undefined') return null
      const searchParams = new URLSearchParams(window.location.search || '')
      const hashQuery = (window.location.hash || '').split('?')[1] || ''
      const hashParams = new URLSearchParams(hashQuery)
      return searchParams.get(key) ?? hashParams.get(key)
    }

    const rawOverride = getParam('isShowVconsole')
    const overrideEnabled = rawOverride != null && !['0', 'false', 'off', 'no'].includes(String(rawOverride).toLowerCase())

    if (isNonWebAndNonProd || overrideEnabled) {
      instance = new VConsole()
    }
  } catch (error) {
    console.error('vconsole error', error)
  }
  return instance
}

const vConsoleInstance = createVConsoleInstance()
export default vConsoleInstance
